// extracted by mini-css-extract-plugin
module.exports = {"link":"link_link__GP3p1","iconLink":"link_iconLink__b7HkE"};